import type { FaireProductEntity } from "../../entity_types/product";

export const p_98ud8uct2p: FaireProductEntity = {
  token: "p_98ud8uct2p",
  type: "product",
  name: "Smooth Coat Detangling & Conditioning Spray",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/ed250026df8efa58d3d92753256887b9da9d9bec8061f5553b0f56349b0a62af.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e94d3035835dabcadb80ed1c8ebecfb8724a68e7234972436b1ee7d3fe76d80c.png",
    "https://cdn.faire.com/fastly/eca9a7e39cae3decf24b7676112ecac9f8edf71fb9638040b82068fe1683c449.png",
    "https://cdn.faire.com/fastly/32736ff5513af6e66407e65c8be81345490f2f1ff3485b2c6b12424414304d8d.png",
    "https://cdn.faire.com/fastly/449f9e30fdd55825fd371099aaa7b2b5a25c926687df6fb5c7265780ed057393.png",
    "https://cdn.faire.com/fastly/4763c17cb5b403b34f1ac3b86e4568256a56ce0bad1efa3f2ced2c05613981df.png",
    "https://cdn.faire.com/fastly/2115ac4b9dcd8c185bf7b70b2e28274675739855f615f0ee6171486202aee172.png",
    "https://cdn.faire.com/fastly/2dd6fa069f3004742604b6eac872637f1b272b6c3010a7761df4ebe75022cb2a.png",
    "https://cdn.faire.com/fastly/b7131a7e3b63a1836024e0a1126cbeeebffc6158d21a81c4468586b87a04556d.png",
    "https://cdn.faire.com/fastly/15e297b2efd0d126261f8bd9ef79a26a7b3ee043afaeb29ec04c20dfcdb65003.png"
  ],
  priceDollars: 9,
  description: "For the smoothest coat your dog's ever had. \n\nWhy we love it: Simple, smooth and stress-free brushing and detangling at home.\n\nVet-Dermatologist Approved | Fragrance-Free | pH-Balanced for Dogs | Lick-Safe | Vegan | Cruelty-Free\n\n",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:39.055Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
